import { observer } from 'mobx-react';
import { FC } from 'react';

import { provide, useDependencies } from '@servicetitan/react-ioc';
import { CenteredSpinner } from '@servicetitan/standalone-ui';
import { Loader } from '@servicetitan/web-components';

import { AutopilotCampaignsStore } from '../stores/autopilot-campaigns.store';

export const AutopilotCampaignsPage: FC = provide({
    singletons: [AutopilotCampaignsStore],
})(
    observer(() => {
        const [{ data, source, basename }] = useDependencies(AutopilotCampaignsStore);

        return (
            <Loader
                basename={basename}
                src={source}
                loadingFallback={<CenteredSpinner />}
                className="w-100"
                data={data}
            />
        );
    }),
);
